import utils from '../../utils/tag-name';

const TAG_NAME = utils.constructTagName('cardradio');

export { TAG_NAME };
